import type { Client, Document } from '@/types';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '@/config/firebase';

export async function usesGeneralAuthorization(firmId: string): Promise<boolean> {
  const firm = await getDoc(doc(db, `firms/${firmId}`));
  return firm.data()?.settings?.hipaaTemplateType === 'general';
}
/** Display selection only: delivery always verifies the actual current bytes on the server. */
export function selectGeneralAuthorization(client: Client, documents: Document[]): Document | null {
  if (client.hipaaAssemblyAssociation) return null;
  const storagePath = client.hipaaAuthorizationStoragePath;
  return documents.find(d => !d.hipaaSourceCandidate && d.hipaaDocumentRole !== 'signed-pages-source' && !d.providerSpecific &&
    ['hipaa_auth', 'hipaa_auth_general', 'hipaa_auth_signed'].includes(d.documentType) &&
    d.protectedDocumentStatus !== 'replaced' && !!storagePath && d.storagePath === storagePath) ?? null;
}

export async function usesAssemblyAuthorization(firmId: string): Promise<boolean> {
  const firm = await getDoc(doc(db, `firms/${firmId}`));
  return firm.data()?.settings?.hipaaDocumentWorkflow === 'assemble';
}
